module.exports = __webpack_public_path__ + "img/in_office.9534e9db.svg";